export default __webpack_public_path__ + "static/media/HDTX_Pemanggilan RUPS 24 Juni 2024.1bf130c9.pdf";